import React, { FC } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Tooltip } from 'src/presentation/components/agent_desktop_components';
import EditPencil from '@ad-scripts/presentation/components/common/icons/edit_pencil';

import useRouter from 'src/presentation/hooks/useRouter';

type EditProps = {
  dataAid?: string;
  id: string;
};

const Edit: FC<EditProps & React.AnchorHTMLAttributes<HTMLAnchorElement>> = ({ id, dataAid, ...rest }) => {
  const { match } = useRouter();

  return (
    <Tooltip message={'Edit'} style={{ left: '5px' }} margin={13}>
      <StyledLink {...rest} data-aid={dataAid || `editLink-${id}`} to={`${match.url}/${id}`}>
        <EditPencil />
      </StyledLink>
    </Tooltip>
  );
};

const StyledLink = styled(Link)`
  visibility: hidden;
  color: ${p => p.theme.colors.gray500};
  cursor: pointer;
  height: 16px;
  & svg {
    height: 16px;
  }

  &:hover {
    color: ${p => p.theme.colors.green400};
  }
`;

export { Edit };
